import { endPoints } from "../../constants/urlConstants";
import { getItemInLocalStorage } from "../../services/localStorage";
import { hasPermission } from "../../utils/roleBasedAccess";
import { getCall, putCall } from "../../services/apiService";
import { GroupedQuestion, ProgramQuestionMap, Question } from "./types";
import type { ProgramDetails } from "./types";
import { S3Client, ListObjectsCommand } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import dayjs from "dayjs";

const DEFAULT_SECTION_ORDERS = {
  FS_BASICDETAILS: 10,
  FS_MAHATRIAQUESTIONS: 20,
  FS_PAYMENTINVOICE: 30,
  FS_TRAVELPLAN: 40,
  FS_ADDITI_0871: 50,
};

const s3 = new S3Client({
  region: process.env.REACT_APP_AWS_REGION, // 'ap-south-1',
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || "", // 'AKIATOWWTX6I3DL2PYXJ',      // ⚠️ Avoid hardcoding in real apps
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY || "", //'xBO1LykVgxozKVqXXxfZX9i661C/1PTU00lGCJ+q',  // ⚠️ Use Cognito or env variables
  },
});

export const getRegistrationQuestionsById = async (id: string) => {
  try {
    const response = await getCall(
      `${endPoints.getRegistrationQuestionsById(id)}`,
    );
    if (response?.data?.statusCode === 200) {
      console.log(
        "Registration questions fetched successfully:",
        response.data.data,
      );
      return response.data.data;
    } else {
      console.error("Error fetching categories:", response?.data?.message);
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
  return [];
};

export const getSeekerDetailsById = async (id: string) => {
  try {
    const response = await getCall(`${endPoints.registrations(id)}`);
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    } else {
      console.error("Error fetching categories:", response?.data?.message);
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
  return [];
};
export const markSeekerAsPaid = async (id: any, payload: any) => {
  try {
    const response = await putCall(
      `${endPoints.markSeekerAsPaid(id)}`,
      payload,
    );
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    } else {
      console.error("Error marking seeker as paid:", response?.data?.message);
    }
  } catch (error) {
    console.error("Error marking seeker as paid:", error);
  }
  return [];
};

export const omitFields = (data: Array<any>, fieldsToOmit: Array<string>) => {
  const updatedFields: Array<any> = [];
  data.forEach((item: any) => {
    if (
      !fieldsToOmit.includes(item.questionType) &&
      !fieldsToOmit.includes(item.questionLabel)
    ) {
      updatedFields.push(item);
    }
  });

  return updatedFields;
};

export const omitFieldsFromProgramQuestionMap = (
  data: ProgramQuestionMap[],
  fieldsToOmit: Array<string>,
) => {
  const updatedFields: Array<any> = [];
  console.log("data in omitFieldsFromProgramQuestionMap", data);
  console.log("fieldsToOmit in omitFieldsFromProgramQuestionMap", fieldsToOmit);
  // Filter out items based on
  data.forEach((item: any) => {
    if (
      !fieldsToOmit.includes(item.question.type) &&
      !fieldsToOmit.includes(item.question.label)
    ) {
      updatedFields.push(item);
    }
  });

  return updatedFields;
};

export const fetchFullNameAndYourPicture = (data: any) => {
  let fullName = "";
  let yourPicture = "";
  data.forEach((item: any) => {
    if (item.questionLabel === "Full Name") {
      fullName = item.answer;
    }
    if (
      item.questionLabel === "Profile Picture" ||
      item.questionLabel === "Upload Profile Picture"
    ) {
      yourPicture = item.answer;

      console.log("yourPicture123", yourPicture);
    }
  });

  return { fullName, yourPicture };
};

export const groupDataBySection = (data: Array<any>, paymentStatus) => {
  const userRole = getItemInLocalStorage("seekerDetails")?.role || ""; // Assuming you store the user role in local storage
  const groupedData = data.reduce((acc, item) => {
    const sectionName = item.sectionName;
    if (!acc[sectionName]) {
      acc[sectionName] = {
        // sectionOrder: item.sectionOrder,
        sectionOrder:
          DEFAULT_SECTION_ORDERS[
            item.sectionKey as keyof typeof DEFAULT_SECTION_ORDERS
          ] || item.sectionOrder,
        items: [],
        sectionKey: item.sectionKey,
      };
    }
    acc[sectionName].items.push(item);
    return acc;
  }, {});

  const sortedSections = Object.keys(groupedData)
    .map((sectionName) => ({
      sectionName,
      sectionOrder: groupedData[sectionName].sectionOrder,
      items: groupedData[sectionName].items,
      isEditable:
        sectionName === "Payment & Invoice"
          ? hasPermission(userRole, sectionName, "U") &&
            !paymentStatus?.includes("completed")
          : hasPermission(userRole, sectionName, "U"),
      sectionKey: groupedData[sectionName].sectionKey,
    }))
    .sort((a, b) => a.sectionOrder - b.sectionOrder);

  return sortedSections;
};

export const getGroupNames = (data: Array<any>) => {
  const groupNames = data.map((item) => {
    return {
      label: item.sectionName,
      status: "pending",
    };
  });
  return groupNames;
};

export const getAllquestionsFromProgram = async (programId: number) => {
  try {
    const response = await getCall(`${endPoints.program}/${programId}`);
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    } else {
      console.error("Error fetching categories:", response?.data?.message);
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
  return [];
};

export const groupQuestionsByFormSectionName = (
  programQuestionMaps: ProgramQuestionMap[],
): Record<string, ProgramQuestionMap[]> => {
  return programQuestionMaps.reduce(
    (acc, programQuestionMap) => {
      const sectionName = programQuestionMap.question.formSection.name;

      if (!acc[sectionName]) {
        acc[sectionName] = [];
      }

      acc[sectionName].push(programQuestionMap);

      return acc;
    },
    {} as Record<string, ProgramQuestionMap[]>,
  );
};

export const ValidateAllSections = (
  groupedQuestions: Record<string, ProgramQuestionMap[]>,
  formData: Record<string, Record<string, any>>,
  setErrors: any,
  sectionName: string,
): boolean => {
  const acceptedQuestionTypes = [
    "apicall",
    "textarea",
    "text",
    "email",
    "date",
    "select",
    "checkbox",
    "radio",
    "file",
    "number",
    "tel",
  ];
  const errors: Record<string, Record<string, string>> = {};
  let hasErrors = false;

  const questions = groupedQuestions[sectionName];

  const sectionErrors: Record<string, string> = {};

  questions.forEach((programQuestionMap) => {
    const question = programQuestionMap.question;

    if (!areDependenciesSatisfied(question, formData[sectionName])) {
      return; // Skip validation if dependencies are not satisfied
    }
    const value = formData[sectionName]?.[question.id];

    const error = validateField(question, value);
    const isAcceptedFeildType = acceptedQuestionTypes.includes(question.type);
    if (error && isAcceptedFeildType) {
      sectionErrors[question.id] = error;
      hasErrors = true; // Mark that there are validation errors
    }
  });

  if (Object.keys(sectionErrors).length > 0) {
    errors[sectionName] = sectionErrors;
  }

  setErrors(errors);

  return hasErrors;
};

export function validateDateInput(
  value: string | Date,
  config: any,
): string | null {
  if (!value) return "Date is required";
  const inputDate = dayjs(value);

  // Static validation: between startDate and endDate
  if (config.dateValidationType === "static") {
    if (
      config.startDate &&
      inputDate.isBefore(dayjs(config.startDate), "day")
    ) {
      return `Date should not be before ${dayjs(config.startDate).format("DD/MM/YYYY")}`;
    }
    if (config.endDate && inputDate.isAfter(dayjs(config.endDate), "day")) {
      return `Date should not be after ${dayjs(config.endDate).format("DD/MM/YYYY")}`;
    }
    return null;
  }
  console.log("config should", config);

  // Dynamic validation: future and past
  const today = dayjs().startOf("day");

  // Past validation (e.g., age should be at least minValue years and at most maxValue years)
  if (config.pastValidation?.enabled) {
    const { unit, minValue, maxValue } = config.pastValidation;
    const diff = today.diff(inputDate, unit);

    if (minValue != null && diff < minValue) {
      return `Date should be at least ${minValue} ${unit} in the past`;
    }
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the past`;
    }
  }

  // Future validation (e.g., date should not be too far in the future)
  if (config.futureValidation?.enabled) {
    const { unit, minValue, maxValue } = config.futureValidation;
    const diff = inputDate.diff(today, unit);

    if (minValue != null && diff < minValue) {
      return `Date should be at least ${minValue} ${unit} in the future`;
    }
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the future`;
    }
  }

  return null; // Valid
}
const validateField = (question: Question, value: any): string | null => {
  const { config } = question;

  if (config.isRequired && (!value || value.toString().trim() === "")) {
    return `${question.label} is required`;
  }

  if (question.type === "date" && value && validateDateInput(value, config)) {
    const currentDate = new Date();
    const inputDate = new Date(value);
    const age = currentDate.getFullYear() - inputDate.getFullYear();
    if (age < config?.minYears) {
      return `${question.label} must be at least ${config.minYears} years old`;
    }
  }
  if (
    value &&
    config.minCharacter &&
    value.toString().length < config.minCharacter
  ) {
    return `${question.label} must be at least ${config.minCharacter} characters`;
  }

  if (
    value &&
    config.maxCharacters &&
    value.toString().length > config.maxCharacters
  ) {
    return `${question.label} must not exceed ${config.maxCharacters} characters`;
  }

  if (question.type === "email" && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address";
    }
  }

  if (config.validationPattern && value) {
    const regex = new RegExp(config.validationPattern);
    if (!regex.test(value)) {
      return `${question.label} format is invalid`;
    }
  }

  return null;
};

export const filterGroupedQuestionsByData = (
  data: Array<any>,
  groupedQuestions: Record<string, ProgramQuestionMap[]>,
): Record<string, ProgramQuestionMap[]> => {
  // Create a set of all questionIds present in the data
  const validQuestionIds = new Set(
    data.flatMap((section) =>
      section.items.map((item: any) => item.questionId),
    ),
  );

  // Filter groupedQuestions based on validQuestionIds
  const filteredGroupedQuestions = Object.keys(groupedQuestions).reduce(
    (acc, sectionName) => {
      const filteredQuestions = groupedQuestions[sectionName].filter(
        (programQuestionMap) =>
          validQuestionIds.has(programQuestionMap.question.id),
      );

      if (filteredQuestions.length > 0) {
        acc[sectionName] = filteredQuestions;
      }

      return acc;
    },
    {} as Record<string, ProgramQuestionMap[]>,
  );

  return filteredGroupedQuestions;
};

export const handleAWSFileUpload = async (
  file: File,
): Promise<string | null> => {
  testS3Connection().then((isConnected) => {
    if (!isConnected) {
      alert("AWS S3 connection failed. Please check your configuration.");
      return null;
    }
    console.log("AWS S3 connection successful");
  });
  const fileKey = `temp/${Date.now().toString()}.${file.type.split("/")[1]}`;
  const fileUrl = `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;
  const blob = await convertFileToBlob(file);
  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET_NAME, // "infinitheism-serverless",
    Key: fileKey,
    Body: blob,
    ContentType: file.type,
  };
  console.log("AWS S3 upload params:", params);
  // Using AWS SDK to upload the image
  const upload = new Upload({
    client: s3,
    params: params,
  });

  await upload.done();
  return fileUrl;
};

const testS3Connection = async () => {
  try {
    const result = await s3.send(
      new ListObjectsCommand({
        Bucket: "infinitheism-serverless",
        MaxKeys: 1,
      }),
    );
    console.log(" AWS is configured correctly", result);
    return true;
  } catch (err) {
    console.error(" AWS configuration error:", err);
    return false;
  }
};

const convertFileToBlob = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const blob = new Blob([arrayBuffer], { type: file.type });
  return blob;
};

const getQuestionValue = (
  sectionQuestions: any,
  questionId: string,
  value: any,
) => {
  let returnValue = "";
  let isApiCallValue = false;
  sectionQuestions.map((question: any) => {
    if (
      question.question.id == questionId &&
      question.question.type === "apicall"
    ) {
      if (
        question.question.questionOptionMaps &&
        question.question.questionOptionMaps.length > 0
      ) {
        question.question.questionOptionMaps.forEach((option: any) => {
          if (option.option.name === value.trim()) {
            isApiCallValue = true;
            returnValue = option.option.id;
          }
        });
      }
    }
  });

  return { returnValue, isApiCallValue };
};

export const transformFormDataToPayload = (
  formData: {
    [key: string]: GroupedQuestion;
  },
  sectionQuestions: any,
  sectionName: string,
): Array<{ questionId: number; answer: string }> => {
  const payload: Array<{ questionId: number; answer: string }> = [];

  const sectionData = formData[sectionName];
  Object.keys(sectionData).forEach((questionId: any) => {
    const value = sectionData[questionId];
    const { isApiCallValue, returnValue } = getQuestionValue(
      sectionQuestions,
      questionId,
      value,
    );

    const finalValue = isApiCallValue ? returnValue : value;
    payload.push({
      questionId: Number(questionId),
      answer: finalValue?.toString() || "",
    });
  });

  return payload;
};

const fetchApiOptions = async (pqm: ProgramQuestionMap) => {
  const apiEndpoint = pqm.question.config?.endPoint;
  if (!apiEndpoint) return;
  try {
    let updatedProgramQuestionMap = [];
    const response = await getCall(apiEndpoint);
    if (response?.data?.statusCode === 200) {
      updatedProgramQuestionMap = response.data.data.data.map((item: any) => ({
        option: {
          id: item.id ?? 8319,
          name: item.name ?? item.fullName,
        },
      }));
      return updatedProgramQuestionMap;
    }
  } catch (error) {
    console.error("Error fetching API options:", error);
    return [];
  }
};

export const getApiCallData = async (
  programInputData: ProgramQuestionMap[],
) => {
  const programData: ProgramQuestionMap[] = await Promise.all(
    programInputData.map(async (pqm: ProgramQuestionMap) => {
      if (pqm.question.type === "apicall") {
        if (
          !pqm.question.questionOptionMaps ||
          pqm.question.questionOptionMaps.length === 0
        ) {
          const updatedOptions = await fetchApiOptions(pqm);
          return {
            ...pqm,
            question: {
              ...pqm.question,
              questionOptionMaps: updatedOptions || [],
            },
          };
        }
      }
      return pqm;
    }),
  );
  return programData;
};

export const groupProgramQuestionsBySection = (
  programQuestions: any[],
  paymentStatus: string | string[] | undefined,
) => {
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";
  const result = programQuestions.reduce(
    (acc, pqm) => {
      const sectionName = pqm.question.formSection.name;
      if (!acc[sectionName]) {
        acc[sectionName] = { sectionOrder: pqm.displayOrder, items: [] };
      }
      return acc;
    },
    {} as Record<string, any[]>,
  );
  const sortedSections = Object.keys(result).map((sectionName) => ({
    sectionName,
    sectionOrder: result[sectionName].sectionOrder,
    items: result[sectionName].items,
    isEditable:
      sectionName === "Payment & Invoice"
        ? hasPermission(userRole, sectionName, "U") &&
          !paymentStatus?.includes("completed")
        : hasPermission(userRole, sectionName, "U"),
  }));
  return sortedSections;
};

export const mergeSections = (arrayOne: any[], arrayTwo: any[]) => {
  const sectionNamesInOne = new Set(arrayOne.map((item) => item.sectionName));
  const uniqueFromTwo = arrayTwo.filter(
    (item) => !sectionNamesInOne.has(item.sectionName),
  );
  return [...arrayOne, ...uniqueFromTwo];
};

export const handleSendInvoice = (seekerId: any) => {
  console.log("Sending invoice for:", seekerId);
  if (seekerId) {
    const response = getCall(`${endPoints.sendInvoice(seekerId)}`);
    console.log("Response from send invoice:", response);
  }
};

export const getGroupedProgramsList = (
  programs: Array<{ id: number; name: string }>,
): Array<{ value: number; label: string }> => {
  return programs.map((program) => ({
    value: program.id,
    label: program.name,
  }));
};

const fetchDataFromApiCall = async (config: any) => {
  // try {
  // You may want to store the endpoint in pqm.question.config or elsewhere
  // For demo, let's assume pqm.question.config.apiEndpoint exists
  if (!config?.endPoint) return;
  try {
    let updatedProgramQuestionMap = [];
    const response = await getCall(config.endPoint);
    if (response?.data?.statusCode === 200) {
      console.log("API options fetched successfully:", response.data.data.data);
      // Map API response to questionOptionMaps format
      updatedProgramQuestionMap = response.data.data.data.map((item: any) => ({
        option: {
          id: item.id ?? 8319,
          name: item.name ?? item.fullName,
        },
      }));
      return updatedProgramQuestionMap;
    }
  } catch (error) {
    console.error("Error fetching API options:", error);
    return [];
  }
};

export const fetchApiResultsFromData = async (groupedDataArray: any[]) => {
  // Iterate over each section
  const updatedSections = await Promise.all(
    groupedDataArray.map(async (section: any) => {
      // For each item in the section
      const updatedItems = await Promise.all(
        section.items.map(async (item: any) => {
          // Check if item has a question object with config
          if (item.questionType === "apicall") {
            // If the question has an 'answer' key
            // Fetch data from API using config
            const apiResult = await fetchDataFromApiCall(item.config);
            // Replace the answer with the API result

            console.log(apiResult, "apiResult in fetchApiResultsFromData");
            let result1: string = "";

            apiResult.forEach((option: any) => {
              const { id, name } = option.option;
              console.log(
                id,
                name,
                item.answer,
                "option.id and item.answer in fetchApiResultsFromData",
              );
              if (id == item.answer) {
                result1 = name;
              }
            });

            return {
              ...item,
              answer: result1, // Update the answer with the fetched data
            };
          }
          // If no update needed, return item as is
          return item;
        }),
      );
      // Return the updated section with updated items
      return {
        ...section,
        items: updatedItems,
      };
    }),
  );
  return updatedSections;
};

export const areDependenciesSatisfied = (question: any, formData: any) => {
  if (
    !question.config.dependsOn ||
    question.config.dependsOn.length === 0 ||
    !formData
  ) {
    return true;
  }

  return question.config.dependsOn.some((dep: any) => {
    if (dep.value === "notNull") {
      return (
        formData[dep.questionId] != undefined &&
        formData[dep.questionId] != null &&
        formData[dep.questionId] != ""
      );
    } else {
      console.log(
        formData[dep.questionId],
        dep.value,
        "formData[dep.questionId] and dep.value in areDependenciesSatisfied",
      );
      const isMatch = formData[dep.questionId] === dep.value;
      if (!isMatch) {
        // Only set if it's different
        // console.log("selectedQuestionId",  "question.id", question.id);
      }
      return isMatch;
    }
  });
};

export const getQuestionIdsWhereThequestionIdIsDependedOn = (
  questionId: string,
  questionMapList: ProgramQuestionMap[],
) => {
  const dependedOnQuestionIds = questionMapList
    .filter((pqm) => {
      // add validation to check if pqm.question.config.dependsOn exists
      if (!pqm.question?.config?.dependsOn) return false;
      return pqm.question?.config?.dependsOn?.some(
        (dep: any) => dep.questionId === questionId,
      );
    })
    .map((pqm) => pqm.question.id);

  return dependedOnQuestionIds;
};

export const getActionOptions = (handleSwapRequest: (row: any) => void,seekerData:any) => {
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";

  const options = [
    // {
    //   label: "download invoice",
    //   action: (row: any) => {
    //     // Handle download invoice logic here
    //     console.log('Download invoice for:', row);
    //   },
    //   imageSource: undefined,
    // },
  ];
  const approvals = seekerData?.approvals;
  const latestApprovalStatus =
    Array.isArray(approvals) && approvals.length > 0
      ? approvals[approvals.length - 1]?.approvalStatus
      : undefined;
      if (
        hasPermission(userRole, "REQ_SWAP_SEEKER", "C") &&
        latestApprovalStatus === "approved"
      ) {
        // Find the latest swap request by createdAt
        let latestSwapStatus = null;
        if (Array.isArray(seekerData?.swapsRequests) && seekerData.swapsRequests.length > 0) {
          const latestSwap = seekerData.swapsRequests.reduce((latest, current) => {
            return new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest;
          }, seekerData.swapsRequests[0]);
          latestSwapStatus = latestSwap.status;
        }
      
        options.push({
          label: "swap request",
          action: (row: any) => handleSwapRequest(row),
          imageSource: undefined,
          disabled: latestSwapStatus === "active", // Disable only if latest swap is active
        });
      }

  return options;
};

// Remove this export - call it in the component instead
// export const menuActionsBasedOnRoles = getOptions();

/**
 * Adds payment-related fields to the payment section data
 * @param fetchedMergedGroupedDataBySection - The merged grouped data by section
 * @param seekerDetails - The seeker details containing payment information
 * @param PAYMENT_STATUSES - Payment status constants
 * @returns Updated section data with payment fields
 */
export const addPaymentFieldsToSection = (
  fetchedMergedGroupedDataBySection: any[],
  seekerDetails: any,
  PAYMENT_STATUSES: Record<string, { value: string; label: string }>,
) => {
  return fetchedMergedGroupedDataBySection?.map((section: any) => {
    if (section?.sectionName?.toLowerCase().includes("payment")) {
      // Find matching payment status label
      const paymentStatusLabel =
        Object.values(PAYMENT_STATUSES).find(
          (status) =>
            status.value === seekerDetails?.paymentDetails?.[0]?.paymentStatus,
        )?.label || "-";

      // Add payment related fields to the items array
      const updatedItems = [
        ...section.items,
        // Only add payment ID fields if payment mode is online
        ...(seekerDetails?.paymentDetails?.[0]?.paymentMode === "online"
          ? [
              {
                questionId: crypto.randomUUID(),
                questionLabel: "Payment ID",
                questionType: "text",
                sectionId: section.sectionId,
                sectionName: section.sectionName,
                sectionOrder: section.sectionOrder,
                answer: seekerDetails?.paymentDetails?.[0]?.id || "-",
              },
              {
                questionId: crypto.randomUUID(),
                questionLabel: "Razorpay Payment ID",
                questionType: "text",
                sectionId: section.sectionId,
                sectionName: section.sectionName,
                sectionOrder: section.sectionOrder,
                answer: seekerDetails?.paymentDetails?.[0]?.razorpayId || "-",
              },
            ]
          : []),
        {
          questionId: crypto.randomUUID(),
          questionLabel: "Payment Status",
          questionType: "text",
          sectionId: section.sectionId,
          sectionName: section.sectionName,
          sectionOrder: section.sectionOrder,
          answer: paymentStatusLabel,
        },
      ];

      return {
        ...section,
        items: updatedItems,
      };
    }
    return section;
  });
};

//Hanlding the visibility of the Mark Payment as Received card
export const showMarkPaymentAsReceivedCard = (
  paymentStatus: boolean,
  reSendInvoice: boolean,
  userRole: string,
  invoicePdfLink: string,
) => {
  // debugger
  if (paymentStatus || reSendInvoice) {
    if (hasPermission(userRole, "MARK_AS_PAID_RESEND_INVOICE", "R")) {
      return true;
    } else if (
      userRole?.includes("relational_manager") &&
      invoicePdfLink?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }
};

// Add the function to get registration status
export const getRegistrationStatus = async (
  registrationId: number,
): Promise<ProgramDetails> => {
  try {
    const response = await getCall(
      `registration/${registrationId}/statuses`,
      undefined,
      false,
    );
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    }
    throw new Error("Failed to get registration status");
  } catch (error) {
    console.error("Error getting registration status:", error);
    throw error;
  }
};

/**
 * Maps sectionKey to the corresponding status value from registrationStatus.
 * @param sectionKey - The sectionKey from groupedDataBySection
 * @param registrationStatus - The status object returned from the API
 * @returns The status value for the section, or null if not found
 */
export const getSectionStatus = (
  sectionKey: string,
  registrationStatus: any,
): string | null => {
  const getCombinedStatus = (fields: string[]) => {
    const values = fields.map((f) => registrationStatus?.[f]).filter(Boolean);
    if (values.length === 0) return "not started";
    if (values.some((v) => typeof v === "string" && v.includes("completed")))
      return "completed";
    if (values.some((v) => typeof v === "string" && v.includes("pending")))
      return "pending";
    return values[0] || "not started";
  };

  switch (sectionKey) {
    case "FS_BASICDETAILS":
      return getCombinedStatus(["basicDetailsRegistrationStatus"]);
    case "FS_PAYMENTINVOICE":
      return getCombinedStatus(["paymentStatus", "invoiceStatus"]);
    case "FS_TRAVELPLAN":
      return getCombinedStatus(["travelInfoStatus", "travelPlanStatus"]);
    case "FS_MAHATRIAQUESTIONS":
      return getCombinedStatus(["basicDetailsRegistrationStatus"]);
    default:
      return "not started";
  }
};

export const getPaymentStatusFromData = (data: any[]) => {
  try {
    // Find the section with sectionName "Payment & Invoice"
    const paymentSection = data.find(
      (section) => section.sectionName === "Payment & Invoice",
    );

    if (!paymentSection || !paymentSection.items) {
      console.log("Payment & Invoice section not found");
      return null;
    }

    // Find the item with questionLabel "Payment Status"
    const paymentStatusItem = paymentSection.items.find(
      (item) => item.questionLabel === "Payment Status",
    );

    if (!paymentStatusItem) {
      console.log("Payment Status question not found");
      return null;
    }

    return paymentStatusItem.answer;
  } catch (error) {
    console.error("Error extracting payment status:", error);
    return null;
  }
};
